/* EnsoProject — localStorage-backed save-for-later store.
   Global API: window.EnsoProject
   Event: 'enso:project:updated' on document, detail: { items, count }
*/
(function() {
  if (window.EnsoProject) return;

  var STORAGE_KEY = 'enso_project';
  var VERSION = 1;

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return { v: VERSION, items: [] };
      var data = JSON.parse(raw);
      if (!data || data.v !== VERSION || !Array.isArray(data.items)) return { v: VERSION, items: [] };
      return data;
    } catch(e) {
      return { v: VERSION, items: [] };
    }
  }

  function write(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch(e) {
      console.error('EnsoProject: failed to write', e);
    }
  }

  function notify() {
    var data = read();
    document.dispatchEvent(new CustomEvent('enso:project:updated', {
      detail: { items: data.items, count: data.items.length }
    }));
  }

  window.EnsoProject = {
    add: function(variant_id, handle) {
      var id = parseInt(variant_id, 10);
      if (!id || !handle) return;
      var data = read();
      if (data.items.some(function(i){ return i.variant_id === id; })) return;
      data.items.push({ variant_id: id, handle: handle, added_at: Date.now() });
      write(data);
      notify();
    },
    remove: function(variant_id) {
      var id = parseInt(variant_id, 10);
      var data = read();
      data.items = data.items.filter(function(i){ return i.variant_id !== id; });
      write(data);
      notify();
    },
    toggle: function(variant_id, handle) {
      var id = parseInt(variant_id, 10);
      if (this.has(id)) { this.remove(id); return false; }
      this.add(id, handle);
      return true;
    },
    has: function(variant_id) {
      var id = parseInt(variant_id, 10);
      return read().items.some(function(i){ return i.variant_id === id; });
    },
    count: function() { return read().items.length; },
    items: function() { return read().items.slice(); },
    clear: function() {
      write({ v: VERSION, items: [] });
      notify();
    }
  };

  // Cross-tab sync
  window.addEventListener('storage', function(e) {
    if (e.key === STORAGE_KEY) notify();
  });

  // Initial dispatch so listeners pick up state on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', notify);
  } else {
    notify();
  }
})();